<template>
  <div class="forgotpwd_wrapper">
    <div class="container">
      <div class="box">
        <div class="login">
          <div class="title">找回密码</div>
          <div class="form login-input login-select">
            <!--<div class="row">-->
            <!--<div class="label">用户名:</div>-->
            <!--<div class="value">-->
            <!--<el-input placeholder="请填写用户名" v-model="model.username" clearable></el-input>-->
            <!--</div>-->
            <!--</div>-->
            <div class="row">
              <div class="label">手机号:</div>
              <div class="value">
                <el-input
                  placeholder="请填写手机号"
                  v-model="model.usermobile"
                  clearable
                ></el-input>
              </div>
            </div>
            <div class="row">
              <div class="label">验证码：</div>
              <div class="value">
                <el-input
                  placeholder="请输入手机验证码"
                  v-model="model.yzm"
                  clearable
                ></el-input>
              </div>
              <div class="yzmbtn" @click="getsms">
                <sec-count-down v-if="sendFlag" @stop="stop"
                  >秒后获取</sec-count-down
                >
                <span v-else>发送验证码</span>
              </div>
            </div>
            <div class="row">
              <div class="label">新密码:</div>
              <div class="value">
                <el-input
                  type="password"
                  placeholder="请输入新密码"
                  v-model="model.userpassword"
                  clearable
                ></el-input>
              </div>
            </div>
            <div class="row">
              <div class="label">确认密码:</div>
              <div class="value">
                <el-input
                  type="password"
                  placeholder="请输入确认密码"
                  v-model="model.confirmpwd"
                  clearable
                ></el-input>
              </div>
            </div>
          </div>

          <div class="btn">
            <div @click="submit">确认重置</div>
          </div>
          <div class="lead">
            <div></div>
            <span class="linkbtn" @click="$router.push({ path: '/login' })"
              >返回登录</span
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";
import Regular from "../assets/js/regular";
import SecCountDown from "../components/common/SecCountDown";
import Md5 from "../assets/js/md5";
export default {
  name: "ForgotPwd",
  components: { SecCountDown },
  data() {
    return {
      role: "",
      options: [{ value: 1, label: "采购人" }],
      model: {
        yzm: "",
        usermobile: "",
        userpassword: "",
        confirmpwd: "",
      },
      errMsg: "",
      sendFlag: false,
      isDisabledBtn: false,
    };
  },
  methods: {
    validate() {
      this.errMsg = "";
      var reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z!@+-=#*$%_]{8,}$/;
      var telphone = Regular.GetRegularExpression("telphone");
      if (this.model.userpassword === "") {
        this.errMsg = "请输入新密码";
      } else if (!reg.test(this.model.userpassword)) {
        this.errMsg = "新密码要求是数字和字符的结合，不能少于8位数";
      } else if (this.model.confirmpwd === "") {
        this.errMsg = "请输入确认密码";
      } else if (this.model.confirmpwd !== this.model.userpassword) {
        this.errMsg = "两次密码输入的不一致";
      } else if (!this.model.usermobile) {
        this.errMsg = "请输入手机号码";
      } else if (!telphone.test(this.model.usermobile)) {
        this.errMsg = "手机号码格式不正确";
      } else if (this.model.yzm === "") {
        this.errMsg = "请输入验证码";
      }
    },
    validate2() {
      var reg = Regular.GetRegularExpression("telphone");
      if (!this.model.usermobile) {
        this.errMsg = "请输入手机号码";
      } else if (!reg.test(this.model.usermobile)) {
        this.errMsg = "手机号码格式不正确";
      } else {
        this.errMsg = "";
      }
    },
    async getsms() {
      this.validate2();
      if (this.errMsg !== "") {
        this.$message({
          message: this.errMsg,
          type: "warning",
        });
        return;
      }
      let userData = await request({
        url: "/web/web/isExistMobile",
        method: "get",
        params: { usermobile: this.model.usermobile, userstatus: 1 },
      });
      if (!userData) {
        this.$message({
          message: "该手机号码不存在！",
          type: "warning",
        });
        return;
      }
      this.model.userid = userData;
      if (this.isDisabledBtn) {
        return;
      }
      let res = await request({
        url: "/sms/send",
        method: "get",
        params: { type: "1", tel: this.model.usermobile },
      });
      this.sendFlag = true;
      this.isDisabledBtn = true;
      this.model.yzmToken = res.data;
      if (res.issuccess) {
        this.$message.success("验证码获取成功");
      } else {
        this.isDisabledBtn = false;
        this.sendFlag = false;
        this.$message.error({
          message: "获取验证码失败，请30秒后再重新获取",
          type: "warning",
        });
      }
    },
    stop() {
      this.isDisabledBtn = false;
      this.sendFlag = false;
    },
    async submit() {
      this.model.userpassword = Md5.md5(this.model.userpassword);
      this.model.confirmpwd = Md5.md5(this.model.confirmpwd);
      let data = await request({
        url: "/web/web/forgetPassword",
        method: "post",
        data: this.model,
      });
      if (data.issuccess === 1) {
        this.$message.success("密码重置成功");
        this.$router.push({ path: "/login" });
      } else {
        this.$message.error("密码重置失败");
        this.isDisabledBtn = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/variables.scss";

@media screen and (min-width: 1201px) {
  .forgotpwd_wrapper {
    width: 100%;
    height: 100%;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    background-image: url("../assets/img/login_bg.png");
    display: flex;
    justify-content: center;
    align-items: center;
    color: $color-black;
    .container {
      width: 1201px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      color: $color-black;
      padding-right: 40px;
      .box {
        border-radius: 3px;
        background-color: $color-bg-white;
        /*设计是425*/
        width: 405px;
        margin: 5px 0;
        .login {
          display: flex;
          flex-direction: column;
          padding: 0 30px;
          .title {
            font-size: $fontsize-large-xxx;
            font-weight: bold;
            padding: 30px 0 20px;
          }
          .form {
            font-size: $fontsize-medium;
            /*设计图是40px*/
            padding-bottom: 10px;
            .row {
              display: flex;
              align-items: center;
              border-bottom: 1px solid $color-line-gray;
              padding: 5px 0;
              /*设计图是40px*/
              margin-bottom: 15px;
              .label {
                width: 60px;
              }
              .value {
                flex: 1;
              }
              .yzmbtn {
                cursor: pointer;
                border: 1px solid $color-orange;
                padding: 11px;
                margin-left: 10px;
                color: $color-orange;
              }
            }
          }
          .btn {
            text-align: center;
            border-radius: 2px;
            background-color: $color-orange;
            padding: 16px;
            font-size: $fontsize-large-x;
            color: #fff;
          }
          .lead {
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-size: $fontsize-medium;
            /*设计图是padding: 30px 0 40px;*/
            padding: 20px 0 20px;
            span {
              cursor: pointer;
              color: $color-orange;
              border-bottom: 1px solid $color-orange;
            }
          }
        }
      }
    }
  }
}

@media screen and (max-width: 1200px) and (min-width: 769px) {
  .forgotpwd_wrapper {
    width: 100%;
    height: 100%;
    overflow: hidden;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    background-image: url(/img/login_bg.2079a222.png);
    .login {
      float: right;
      margin: 5em 5em;
      width: 25em;
      border-radius: 5px;
      background-color: #fff;
      -moz-box-shadow: 1px 1px 7px #9c9c9c;
      -webkit-box-shadow: 1px 1px 7px #9c9c9c;
      box-shadow: 1px 1px 7px #9c9c9c;
      .title {
        font-weight: bold;
        margin: 1em 1em;
      }
      .form {
        .row {
          display: flex;
          align-items: center;
          margin: 1em 0;
          .label {
            width: 5em;
            text-align: right;
            margin-right: 0.3em;
          }
          .value {
          }
          .yzmbtn {
            font-size: 0.6em;
            border: 0.1em dotted #f46722;
            color: #f46722;
            padding: 0.2em 0.2em;
          }
        }
      }
      .btn {
        margin: 2em 1em 1em 1em;
        text-align: center;
        background-color: #f46722;
        height: 3em;
        line-height: 3em;
        color: #fff;
        border-radius: 2px;
      }
      .lead {
        text-align: right;
        color: #f46722;
        margin-right: 1em;
        font-size: 0.9em;
        padding: 0 1em 1em 1em;
        text-decoration: underline;
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .login {
    margin: 1em 0.6em;
    padding: 0.6em 0.3em;
    border-radius: 1em;
    -moz-box-shadow: 1px 1px 7px #9c9c9c;
    -webkit-box-shadow: 1px 1px 7px #9c9c9c;
    box-shadow: 1px 1px 7px #9c9c9c;
    .title {
      font-weight: bold;
      margin: 1em 1em;
    }
    .form {
      .row {
        display: flex;
        align-items: center;
        margin: 1em 0;
        .label {
          width: 5em;
          text-align: right;
          margin-right: 0.3em;
        }
        .value {
        }
        .yzmbtn {
          font-size: 0.6em;
          border: 0.1em dotted #f46722;
          color: #f46722;
          padding: 0.2em 0.2em;
        }
      }
    }
    .btn {
      margin: 2em 1em 1em 1em;
      text-align: center;
      background-color: #f46722;
      height: 3em;
      line-height: 3em;
      color: #fff;
      border-radius: 2px;
    }
    .lead {
      text-align: right;
      color: #f46722;
      margin-right: 1em;
      font-size: 0.9em;
      padding: 0 1em 1em 1em;
      text-decoration: underline;
    }
  }
}
</style>